import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import axios, { AxiosResponse } from 'axios';
import { Capability } from 'src/models/user.model';

type InitialState = {
  fetchLoading: boolean;
  fetchFailure: boolean;
  fetchSuccess: boolean;
  capabilitiesWithEgualRoleId: Capability[];
  capabilities: Capability[];
};

const INITIAL_STATE: InitialState = {
  fetchLoading: false,
  fetchFailure: false,
  fetchSuccess: false,
  capabilitiesWithEgualRoleId: [] as Capability[],
  capabilities: [] as Capability[],
};

export const getCapabilities = createAsyncThunk('capabilities/get', async (_, { rejectWithValue }) => {
  try {
    const response: AxiosResponse<Capability[]> = await axios.get(`/api/capabilities`);

    return response.data;
  } catch (error: any) {
    return rejectWithValue(error.message);
  }
});

export const capabilitySlice = createSlice({
  name: 'capabilities',
  initialState: INITIAL_STATE,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(getCapabilities.pending, (state: InitialState) => {
      return {
        ...state,
        fetchLoading: true,
        fetchFailure: false,
        fetchSuccess: false,
      };
    });

    builder.addCase(getCapabilities.fulfilled, (state: InitialState, action: PayloadAction<Capability[]>) => {
      return {
        ...state,
        fetchLoading: false,
        fetchFailure: false,
        fetchSuccess: true,
        capabilities: action.payload,
      };
    });

    builder.addCase(getCapabilities.rejected, (state: InitialState) => {
      return {
        ...state,
        fetchLoading: false,
        fetchFailure: true,
        fetchSuccess: false,
      };
    });
  },
});

export default capabilitySlice.reducer;
